<form [formGroup]="form" (ngSubmit)="model ? update() : create()" appPermissionControl="P220F0001">
    <div class="form-row">
        <div class="form-field">
            <p-dropdown formControlName="sAgencia" 
                [options]="agencias" 
                optionLabel="descripcion"
                optionValue="valor" 
                [filter]="true" 
                [showClear]="true" 
                appendTo="body"
                placeholder="Seleccione N° Agencia"
                class="w-100" appPermissionControl="P220K0001">
            </p-dropdown>
            <label>N° Agencia</label>
        </div>
        <div class="form-field">
            <p-dropdown formControlName="clave" 
                [options]="claves" 
                optionLabel="descripcion"
                optionValue="valor" 
                [filter]="true" 
                [showClear]="true" 
                appendTo="body"
                placeholder="Seleccione Clave"
                class="w-100" appPermissionControl="P220K0002">
            </p-dropdown>
            <label>Clave</label>
        </div>
        <div class="form-field">
            <input pInputText type="text" formControlName="nombre_titular" class="form-control"
                [placeholder]="'Ingrese nombre del titular'" appPermissionControl="P220K0003">
            <label>Nombre Titular</label>
        </div>
        <div class="form-field">
            <input pInputText type="text" formControlName="calle" class="form-control"
                [placeholder]="'Ingrese calle'" appPermissionControl="P220K0004">
            <label>Calle</label>
        </div>
        <div class="form-field">
            <input pInputText type="text" formControlName="numero_ext" class="form-control"
                [placeholder]="'Ingrese número exterior'" appPermissionControl="P220K0005">
            <label>Exterior</label>
        </div>
        <div class="form-field">
            <input pInputText type="text" formControlName="numero_int" class="form-control"
                [placeholder]="'Ingrese número interior'" appPermissionControl="P220K0006">
            <label>Interior</label>
        </div>
        <div class="form-field">
            <input pInputText type="text" formControlName="colonia" class="form-control"
                [placeholder]="'Ingrese colonia'" appPermissionControl="P220K0007">
            <label>Colonia</label>
        </div>
        <div class="form-field">
            <p-dropdown formControlName="cve_estado" 
                [options]="estados" 
                optionLabel="descripcion"
                optionValue="valor" 
                [filter]="true" 
                [showClear]="true" 
                appendTo="body"
                placeholder="Seleccione Estado"
                class="w-100" appPermissionControl="P220K0008">
            </p-dropdown>
            <label>Estado</label>
        </div>
        <div class="form-field">
            <p-dropdown formControlName="ciudad" 
                [options]="ciudades" 
                optionLabel="descripcion"
                optionValue="valor" 
                [filter]="true" 
                [showClear]="true" 
                [disabled]="!form.get('cve_estado')?.value"
                appendTo="body"
                placeholder="Seleccione Ciudad"
                class="w-100" appPermissionControl="P220K0009">
            </p-dropdown>
            <label>Ciudad</label>
        </div>
        <div class="form-field">
            <input pInputText type="text" formControlName="del_muni" class="form-control"
                [placeholder]="'Ingrese delegación'" appPermissionControl="P220K0010">
            <label>Delegación</label>
        </div>
        <div class="form-field">
            <input pInputText type="number" formControlName="cp" class="form-control"
                [placeholder]="'Ingrese código postal'" appPermissionControl="P220K0011">
            <label>Código Postal</label>
        </div>
        <div class="form-field">
            <input pInputText type="text" formControlName="rfc" class="form-control"
                [placeholder]="'Ingrese R.F.C'" appPermissionControl="P220K0012">
            <label>R.F.C</label>
        </div>
        <div class="form-field">
            <input pInputText type="text" formControlName="telefono" class="form-control"
                [placeholder]="'Ingrese teléfono'" appPermissionControl="P220K0013">
            <label>Teléfono</label>
        </div>
        <div class="form-field">
            <input pInputText type="text" formControlName="telefono2" class="form-control"
                [placeholder]="'Ingrese teléfono 2'" appPermissionControl="P220K0014">
            <label>Teléfono 2</label>
        </div>
        <div class="form-field">
            <input pInputText type="text" formControlName="fax" class="form-control"
                [placeholder]="'Ingrese fax'" appPermissionControl="P220K0015">
            <label>N° Fax</label>
        </div>
        <div class="form-field">
            <p-dropdown formControlName="sEmpresa" 
                [options]="empresas" 
                optionLabel="descripcion"
                optionValue="valor" 
                [filter]="true" 
                [showClear]="true" 
                appendTo="body"
                placeholder="Seleccione Empresa"
                class="w-100" appPermissionControl="P220K0016">
            </p-dropdown>
            <label>Empresa</label>
        </div>
        <div class="form-field">
            <p-dropdown formControlName="regional" 
                [options]="regionales" 
                optionLabel="descripcion"
                optionValue="valor" 
                [filter]="true" 
                [showClear]="true" 
                appendTo="body"
                placeholder="Seleccione Regional"
                class="w-100" appPermissionControl="P220K0017">
            </p-dropdown>
            <label>Regional</label>
        </div>
        <div class="form-field">
            <input pInputText type="number" formControlName="codigoInterno" class="form-control"
                [placeholder]="'Ingrese código externo'" appPermissionControl="P220K0018">
            <label>Código Externo</label>
        </div>
        <div class="form-field">
            <p-dropdown formControlName="tipo" 
                [options]="tipos" 
                optionLabel="descripcion"
                optionValue="valor" 
                [filter]="true" 
                [showClear]="true" 
                appendTo="body"
                placeholder="Seleccione Tipo"
                class="w-100" appPermissionControl="P220K0019">
            </p-dropdown>
            <label>Tipo</label>
        </div>
        <div class="form-field">
            <p-dropdown formControlName="supervisor" 
                [options]="supervisores" 
                optionLabel="descripcion"
                optionValue="valor" 
                [filter]="true" 
                [showClear]="true" 
                appendTo="body"
                placeholder="Seleccione Supervisor"
                class="w-100" appPermissionControl="P220K0020">
            </p-dropdown>
            <label>Supervisor</label>
        </div>
        <div class="form-field">
            <p-dropdown formControlName="sSucursal" 
                [options]="sucursales" 
                optionLabel="descripcion"
                optionValue="valor" 
                [filter]="true" 
                [showClear]="true" 
                [disabled]="!form.get('sEmpresa')?.value"
                appendTo="body"
                placeholder="Seleccione Sucursal"
                class="w-100" appPermissionControl="P220K0021">
            </p-dropdown>
            <label>Sucursal</label>
        </div>
        <div class="form-field">
            <input pInputText type="number" formControlName="diasEspera" class="form-control"
                [placeholder]="'Ingrese días de espera'" appPermissionControl="P220K0022">
            <label>Días espera</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading" appPermissionControl="P220B0001">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openAgenda()" appPermissionControl="P220B0002">
            <mat-icon>schedule</mat-icon>
            Agenda
        </button>
    </div>
</form>

<app-agenda-modal #agendaModal [gestor]="model"></app-agenda-modal>

<style>
    :host ::ng-deep .form-row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 1rem;
        gap: 1rem;
    }

    :host ::ng-deep .form-field {
        flex: 1 1 calc(25% - 1rem);
        min-width: 200px;
        display: flex;
        flex-direction: column-reverse;
        position: relative;
    }

    :host ::ng-deep .form-control {
        width: 100%;
        padding: 0.5rem;
        font-size: 1rem;
        border: 1px solid #ced4da;
        border-radius: 4px;
        background: #fff;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    :host ::ng-deep .form-control:disabled {
        background: #e0e0e0 !important;
        color: #555 !important;
        opacity: 1 !important;
    }

    :host ::ng-deep .form-field label {
        font-size: 0.85rem;
        color: #6c757d;
        margin-bottom: 0.25rem;
    }

    :host ::ng-deep .button-section {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    :host ::ng-deep .w-100 {
        width: 100%;
    }
</style> 